module.exports = __webpack_public_path__ + "119e497d6dc2e18469944f1ba1499633.MP3";